var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"svg-icon",class:{
    'm-loading': !_vm.type,
    'm-wipe': _vm.type === 'wipe'
  },style:({
    width: _vm.width + 'px',
    height: _vm.width + 'px'
  }),attrs:{"viewBox":"0 0 50 50"}},[(_vm.bgColor)?_c('circle',{staticClass:"bg-path",style:({
      stroke: _vm.bgColor
    }),attrs:{"stroke":_vm.bgColor,"cx":"25","cy":"25","r":"20"}}):_vm._e(),_vm._v(" "),_c('circle',{staticClass:"active-path",style:({
      stroke: _vm.color
    }),attrs:{"cx":"25","cy":"25","r":"20"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a39b29c8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/m/loading/loading.vue
// module id = null
// module chunks = 